import { CommandContribution } from '@patsnap/tahiti-core/common/command';
import { CreateReportCommandContribution } from './create-report-contribution';
import { createReportDialog } from './create-report-service';
import { CreateReportDialogService } from './create-report-service.interface';
export function createReportModule(bind) {
    bind(CommandContribution).to(CreateReportCommandContribution);
    bind(CreateReportDialogService).toDynamicValue(createReportDialog());
}
